// extracted by mini-css-extract-plugin
var _1 = "RequestWizardAIWizardFilledChip-modulechip__wLZ57";
var _2 = "RequestWizardAIWizardFilledChip-modulechipText__vvjp2";
export { _1 as "chip", _2 as "chipText" }
